import { render, staticRenderFns } from "./FormSections.vue?vue&type=template&id=6403bfed&scoped=true"
import script from "./FormSections.vue?vue&type=script&lang=js"
export * from "./FormSections.vue?vue&type=script&lang=js"
import style0 from "./FormSections.vue?vue&type=style&index=0&id=6403bfed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6403bfed",
  null
  
)

export default component.exports